var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 25,
    viewBox: "0 0 512 512",
    width: 25,
    fill: "#42738d",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m437 248.5c-7.518 0-14.776 1.125-21.629 3.193l-17.873-33.193h9.502c8.284 0 15-6.716 15-15v-60c0-10.823-11.14-18.086-21.041-13.729l-41.424 18.227-14.328-26.608c-2.616-4.859-7.688-7.889-13.207-7.889h-60c-3.979 0-7.794 1.581-10.606 4.394l-30 30c-5.858 5.858-5.858 15.355 0 21.213 5.857 5.858 15.355 5.858 21.213 0l25.606-25.606h44.828l8.959 16.636v28.765c-38.015 2.033-66.988 11.553-90 21.237v98.36h45c9.882 0 19.315-1.939 27.962-5.428-12.279 20.954-31.389 35.428-57.962 35.428h-90c-8.284 0-15 6.716-15 15s6.716 15 15 15h90c68.515 0 105-65.755 105-135v-15h1.426l25.549 47.448c-16.473 13.769-26.975 34.454-26.975 57.552 0 41.355 33.645 75 75 75s75-33.645 75-75-33.645-75-75-75zm0 120c-24.813 0-45-20.187-45-45 0-11.623 4.43-22.23 11.689-30.224l20.104 37.335c3.935 7.308 13.038 10.017 20.318 6.096 7.294-3.928 10.023-13.024 6.096-20.318l-20.116-37.357c27.349-4.232 51.909 17 51.909 44.469 0 24.812-20.187 44.999-45 44.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212 308.5v-84.85c-26.83 12.135-42.668 16.548-67.432-1.739-6.204-5.686-39.538-33.411-99.568-33.411-8.284 0-15 6.716-15 15s6.716 15 15 15c40.681 0 65.457 14.865 75 21.993v23.048c-12.544-9.438-28.129-15.041-45-15.041-41.355 0-75 33.645-75 75s33.645 75 75 75 75-33.645 75-75c0-5.136-.521-10.152-1.509-15zm-137 60c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 323.5,
    r: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiking);
export default __webpack_public_path__ + "static/media/biking.a2088f0d9b29e0b49919d2b386a474e8.svg";
export { ForwardRef as ReactComponent };